import { Breadcrumbs, Button, IconButton, Typography } from "@mui/material";
import DefaultTemplate from "@/templates/DefaultTemplate/DefaultTemplate";
import { PageHeader, PageContent } from "@adl/smart-ui-library";
import { useAppSelector, useAppDispatch } from "@/hooks";
import { setSelectedCase, selectSelectedCase } from "@/redux/casesSlice";
import CaseProfileWrapper from "@/components/CaseProfileWrapper";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useMsal } from "@azure/msal-react";
import Notifications from "@/components/Notifications";
import { setSelectedTasks } from "@/redux/tasksSlice";
import VaultIcon from "../../components/VaultIcon/VaultIcon";
import VaultTextLogo from "@/components/VaultTextLogo";
import { useNavigate } from "react-router-dom";

const SelectedCasePage = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();
  const caseProfile = useAppSelector(selectSelectedCase);

  const onLogout = () => {
    instance.logout();
  };

  const onTaskBtnClick = () => {
    appDispatch(setSelectedTasks([]));
    navigate(`/tasks`);
  };

  const onHomeBtnClick = () => {
    appDispatch(setSelectedCase(null));
    navigate(`/`);
  };

  return (
    <DefaultTemplate paddingTop={200}>
      <>
        <PageHeader
          logo={
            <VaultIcon width={40} height={40} handleClick={onHomeBtnClick} />
          }
          navigation={
            <>
              <Notifications />
              <Button onClick={onTaskBtnClick}>Tasks</Button>
              <Button onClick={onLogout}>Logout</Button>
            </>
          }
          subHeader={
            <Breadcrumbs
              aria-label="breadcrumb"
              separator={<NavigateNextIcon fontSize="small" />}
            >
              <IconButton onClick={onHomeBtnClick}>
                <HomeOutlinedIcon />
              </IconButton>
              <Typography color="text.primary">
                {caseProfile?.P_number}
              </Typography>
            </Breadcrumbs>
          }
        >
          <VaultTextLogo />
        </PageHeader>
        <PageContent>
          <CaseProfileWrapper />
        </PageContent>
      </>
    </DefaultTemplate>
  );
};

export default SelectedCasePage;
